// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AmbientController from "./ambient_controller"
application.register("ambient", AmbientController)

import ConvergeController from "./converge_controller"
application.register("converge", ConvergeController)

import CountUpController from "./count_up_controller"
application.register("count-up", CountUpController)

import DemoController from "./demo_controller"
application.register("demo", DemoController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MagneticController from "./magnetic_controller"
application.register("magnetic", MagneticController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import NavDropdownController from "./nav_dropdown_controller"
application.register("nav-dropdown", NavDropdownController)

import PointerGlowController from "./pointer_glow_controller"
application.register("pointer-glow", PointerGlowController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ScrollSceneController from "./scroll_scene_controller"
application.register("scroll-scene", ScrollSceneController)

import ScrubController from "./scrub_controller"
application.register("scrub", ScrubController)

import SplitTextController from "./split_text_controller"
application.register("split-text", SplitTextController)
